export const PAGE_SIZE_OPTIONS = [25, 50, 100];
export const INITIAL_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];